import { render, staticRenderFns } from "./DistrictAdminManagement.vue?vue&type=template&id=09acc069&scoped=true&"
import script from "./DistrictAdminManagement.vue?vue&type=script&lang=js&"
export * from "./DistrictAdminManagement.vue?vue&type=script&lang=js&"
import style0 from "./DistrictAdminManagement.vue?vue&type=style&index=0&id=09acc069&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09acc069",
  null
  
)

export default component.exports